import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <>
      <div className="header-area">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="user-menu">
                <ul>
                  <li>
                    <Link to="/">
                      <i className="fa fa-user"></i> My Account
                    </Link>
                  </li>
                  <li>
                    <Link to="/details">
                      <i className="fa fa-bell"></i> Details
                    </Link>
                  </li>
                  {/* <li>
                    <Link to="/shop">
                      <i className="fa fa-shopping-cart"></i> Shop
                    </Link>
                  </li> */}
                  {/* <li>
                    <Link href="checkout.html">
                      <i className="fa fa-user"></i> Checkout
                    </Link>
                  </li> */}
                  <li>
                    <Link to="#">
                      <i className="fa fa-sign-in"></i> Login
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-4">
              <div className="header-right">
                <ul className="list-unstyled list-inline">
                  <li>
                    <Link to="/cart">
                      <i className="fa fa-shopping-cart"></i> My Cart
                    </Link>
                  </li>
                  {/* <li className="dropdown dropdown-small">
                    <a
                      data-toggle="dropdown"
                      data-hover="dropdown"
                      className="dropdown-toggle"
                      href="#"
                    >
                      <span className="key">currency :</span>
                      <span className="value">USD </span>
                      <b className="caret"></b>
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <Link to="#">USD</Link>
                      </li>
                      <li>
                        <Link to="#">INR</Link>
                      </li>
                      <li>
                        <Link to="#">GBP</Link>
                      </li>
                    </ul>
                  </li> */}

                  {/* <li className="dropdown dropdown-small">
                    <a
                      data-toggle="dropdown"
                      data-hover="dropdown"
                      className="dropdown-toggle"
                      href="#"
                    >
                      <span className="key">language :</span>
                      <span className="value">English </span>
                      <b className="caret"></b>
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <Link to="#">English</Link>
                      </li>
                      <li>
                        <Link to="#">French</Link>
                      </li>
                      <li>
                        <Link to="#">German</Link>
                      </li>
                    </ul>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="site-branding-area">
        <div className="container">
          <div className="row">
            <div className="col-sm-6">
              <div className="logo">
                <h1>
                  <Link to="/">
                    <h3 style={{ marginLeft: "2.5rem" }}>Store</h3>
                  </Link>
                </h1>
              </div>
            </div>

            <div className="col-sm-6">
              <div className="shopping-item">
                <Link to="/cart">
                  Cart - <span className="cart-amunt">$100</span>
                  <i className="fa fa-shopping-cart"></i>
                  <span className="product-count">5</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
